module.exports = new __parcel__URL__("73091300.fdac9bc1.jpg").toString();